import { render } from "./SOSAlertMaster.vue?vue&type=template&id=311de5c8&scoped=true"
import script from "./SOSAlertMaster.vue?vue&type=script&lang=js"
export * from "./SOSAlertMaster.vue?vue&type=script&lang=js"

import "./SOSAlertMaster.vue?vue&type=style&index=0&id=311de5c8&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MSRTC\\MSRTC-CODE\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311de5c8"]])

export default __exports__